import React from "react";
import {
    TextField,
    ArrayField,
    Datagrid,
    useRecordContext
} from 'react-admin';

const VerificationArrayField = (props) => {
    const verified = {backgroundColor: '#19BE6F'};
    const needVerification = {backgroundColor: '#FFD600'};
    const notVerified = {backgroundColor: '#FA594F'};

    const TextFieldWithRecordContext = (props) => {
        const record = useRecordContext();
        return (
            <TextField {...props} style={record.verificationStatus === 'Верифіковано' ? verified :
                record.verificationStatus === 'Не верифіковано' ? notVerified : needVerification}/>
        );
    }

    return (
        <ArrayField {...props}>
            <Datagrid>
                <TextField label="Напрямок" source="part" />
                <TextFieldWithRecordContext label="Верифікація" source="verificationStatus" />
                <TextField label="Причина" source="verificationReason" />
                <TextField label="Коментар" source="verificationComment" />
            </Datagrid>
        </ArrayField>
    );
}

export default VerificationArrayField;
